import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Table, Button, Pagination } from "react-bootstrap";
import { FaEdit, FaTrash, FaArrowLeft } from "react-icons/fa";
import appConstants from "../constants/appConstants";
import Layout from "../components/Layout";

const getAuthToken = () => localStorage.getItem("authToken");

const JournalList = () => {
    const [journals, setJournals] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const limit = 50;
    const navigate = useNavigate();

    useEffect(() => {
        fetchJournals(currentPage);
    }, [currentPage]);

    const fetchJournals = async (page) => {
        const token = getAuthToken();
        if (!token) return alert("Unauthorized! Please log in.");
        try {
            const response = await axios.get(`${appConstants.API_ROOT_URL}get-journals?page=${page}&limit=${limit}`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            setJournals(response.data.journals);
            setTotalPages(response.data.pagination.total_pages);
        } catch (error) {
            console.error("Error fetching journals:", error);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this journal?")) return;

        const token = getAuthToken();
        if (!token) return alert("Unauthorized! Please log in.");

        try {
            const response = await axios.post(
                `${appConstants.API_ROOT_URL}delete-journal`,
                { journal_id: id },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            alert(response.data.message || "Journal deleted successfully!");
            fetchJournals(currentPage);
        } catch (error) {
            console.error("Error deleting journal:", error);
            alert(error.response?.data?.message || "Error deleting journal. Please try again.");
        }
    };

    return (
        <Layout>
            <div className="p-3 bg-light">
                <Button variant="secondary" onClick={() => navigate(-1)}>
                    <FaArrowLeft /> Back
                </Button>
                <h5 className="mt-3">Journal Entries</h5>
                <Table striped bordered hover className="mt-3">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>No</th>
                            <th>Entries</th>
                            <th>Description</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {journals.map(journal => (
                            <tr key={journal.id}>
                                <td>{journal.date}</td>
                                <td>{journal.journal_number}</td>
                                <td>
                                    <ul className="m-0 p-0 list-unstyled">
                                        {journal.entries && journal.entries.map((entry, index) => (
                                            <li key={index}>
                                                {entry.account_name} - {entry.debit_credit === 'D' ? "Debit" : "Credit"}: {entry.amount}
                                            </li>
                                        ))}
                                    </ul>
                                </td>
                                <td>{journal.description}</td>
                                <td>
                                    <Button variant="warning" size="sm" onClick={() => navigate(`/edit-journal/${journal.id}`)}>
                                        <FaEdit />
                                    </Button>
                                    <Button variant="danger" size="sm" className="ms-2" onClick={() => handleDelete(journal.id)}>
                                        <FaTrash />
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>

                <Pagination>
                    <Pagination.Prev disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)} />
                    {[...Array(totalPages)].map((_, index) => (
                        <Pagination.Item key={index} active={index + 1 === currentPage} onClick={() => setCurrentPage(index + 1)}>
                            {index + 1}
                        </Pagination.Item>
                    ))}
                    <Pagination.Next disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)} />
                </Pagination>
            </div>
        </Layout>
    );
};

export default JournalList;
